<template>
    <div v-if="config.display" :style="{'width': config.width}" class="control e-control url-container">
        <div v-if="asField">
            <display-value :id="config.id" :value="config.url"></display-value>
        </div>
        <div v-else>
            <a :href="config.url" target="_blank" :title="config.text" :data-test-id="dataTestId">
                {{config.text}}
            </a>
            <p v-if="config.description">{{config.description}}</p>
        </div>
    </div>
</template>

<script>
import { controlMixins } from "./controlMixins.js";

export const urlComponent = {
    mixins: [controlMixins],
};

export default urlComponent;
</script>
<style>
    .control.e-control.url-container {
        background: #eff6f5;
        color: #062955;
        border: 1px dashed #73d0c5;
        border-radius: 4px;
        font-size: 16px;
        display: inline-block;
    }
    .control.e-control.url-container a {
        padding: 12px 16px;
        display: block;
    }
    .control.e-control.url-container p {
        border-top: 1px solid #73d0c5;
        padding: 8px 4px 0 4px;
        margin: 0 16px 12px 16px;
    }
</style>
